const bannerActions = {
  BANNER_DISPLAY_IN_MODAL: 0,
  BANNER_APP_REDIRECT: 1,
  BANNER_EXTERNAL_REDIRECT: 2,
}

module.exports = {
  bannerActions,
}
